import type { ChangeEvent } from "react";

import type { SubscriptionResponse } from "~/generated/graphql";

interface TextObjectProps {
  title: string;
  duration: string;
  freeTrial: string;
}
export interface LightboxOfferProps {
  offerTab?: string;
  onTabChange?: (
    _event: ChangeEvent<HTMLElement>,
    selected: string,
  ) => void | undefined;
  basicOffer?: SubscriptionResponse;
  plusOffer?: SubscriptionResponse;
  freeTrialDays?: number;
}

export interface LightboxOfferDeviceProps extends LightboxOfferProps {
  text: {
    textBasic: TextObjectProps;
    textPlus: TextObjectProps;
  };
}

export interface LightboxOfferSubscriptionsProps {
  basicOffer?: SubscriptionResponse;
  plusOffer?: SubscriptionResponse;
  freeTrialDays?: number;
  isActiveTab?: boolean;
  text: {
    textBasic: TextObjectProps;
    textPlus: TextObjectProps;
  };
}

export interface LightboxOfferSubtitleProps {
  freeTrialDays?: number;
}
export enum BgWrapperColor {
  PLUS = "primary.20",
  BASIC = "neutral.10",
}
export interface LightboxOfferWrapperProps {
  color?: BgWrapperColor;
}

export interface LightboxOfferSubscriptionSingleProps {
  offer?: SubscriptionResponse;
  isActiveTab?: boolean;
  text: TextObjectProps;
}
